import { Box, Typography } from "@mui/material";
import { COLORS } from "../../../ui/Theme";
import { useDomesticMarketProductPriceChart } from "../../../context/domestic-market/product-price-chart/DomesticMarketProductPriceChartContext";

const DomesticMarketProductPriceTab = () => {
  const { selectedTab, setSelectedTab } = useDomesticMarketProductPriceChart();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: { xs: "100%", md: "50%", lg: "40%", xl: "30%" },
        margin: "auto",
        gap: 0.5,
        padding: "4px",
        bgcolor: COLORS.INPUTBG,
        borderRadius: "12px",
        height: "40px",
      }}
    >
      <button
        onClick={() => setSelectedTab("producer")}
        className={`btn ${selectedTab === "producer" && "btn-softblue"}`}
      >
        <Typography sx={{ fontSize: "10px", fontWeight: 900 }}>
          تولید کننده
        </Typography>
      </button>
      <button
        onClick={() => setSelectedTab("category")}
        className={`btn ${selectedTab === "category" && "btn-softblue"}`}
      >
        <Typography sx={{ fontSize: "10px", fontWeight: 900 }}>
          دسته بندی
        </Typography>
      </button>
    </Box>
  );
};

export default DomesticMarketProductPriceTab;
